// Construye un resumen de texto de la ficha de cata para dar contexto a Somm.
const AROMA_KEYS = ["Frutales", "Florales", "Herbáceos", "Especiados", "Minerales", "Balsámicos", "Fermentativos", "Crianza"];

function pick(obj, pairs) {
  return pairs
    .map(([label, val]) => {
      const v = Array.isArray(val) ? (val.length ? val.join(", ") : "") : val;
      return v ? `${label}: ${v}` : null;
    })
    .filter(Boolean)
    .join("; ");
}

export function buildTastingContext(wine = {}, t = {}) {
  const v = t.visual || {};
  const o = t.olfativo || {};
  const g = t.gustativo || {};
  const ob = t.observaciones || {};
  const aromas = AROMA_KEYS.flatMap((f) => o[`aromas_${f}`] || []);

  const lines = [];
  lines.push(pick(wine, [
    ["Vino", wine.nombre], ["Bodega", wine.bodega], ["País", wine.pais], ["Región", wine.region],
    ["D.O.", wine.denominacion], ["Variedad", wine.variedad], ["Tipo", wine.tipo], ["Añada", wine.anada], ["Alcohol", wine.alcohol],
  ]));
  const visual = pick(v, [["Color", v.color], ["Intensidad", v.intensidad], ["Limpidez", v.limpidez], ["Brillantez", v.brillantez]]);
  if (visual) lines.push("Visual → " + visual);
  const olf = pick(o, [["Intensidad", o.intensidad], ["Desarrollo", o.desarrollo], ["Carácter", o.caracter], ["Aromas", aromas]]);
  if (olf) lines.push("Olfativo → " + olf);
  const gus = pick(g, [["Dulzor", g.dulzor], ["Acidez", g.acidez], ["Alcohol", g.alcohol], ["Taninos", g.taninos_cantidad], ["Cuerpo", g.cuerpo], ["Final", g.final]]);
  if (gus) lines.push("Gustativo → " + gus);
  if (t.puntuacion) lines.push("Puntuación: " + t.puntuacion + "/100");
  if (ob.notas) lines.push("Notas: " + ob.notas);

  return lines.filter(Boolean).join("\n") || "Ficha de cata sin datos aún.";
}
